<template>
  <el-row :gutter="20">
    <el-col :span="18">
      <div class="grid-content bg-purple">
        <div class="table-c">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td width="9%">时段</td>
              <td width="13%">周一</td>
              <td width="13%">周二</td>
              <td width="13%">周三</td>
              <td width="13%">周四</td>
              <td width="13%">周五</td>
              <td width="13%">周六</td>
              <td width="13%">周日</td>
            </tr>
            <tr >
              <td width="9%">09:00</td>
              <td width="13%" v-for="(v,index) in list" :key="index"   :class="[{'tob': Number(v.li1) == 1, 'tob-t': Number(v.li1) == 3}]"                                              
                @mouseenter.self="showEwm(index,$event)" @mouseleave.self="showEwm(index,$event)" @click="ccsv()">
                <i v-if="!v.li2 == true">{{v.li5}}</i>
                <div v-else>
                  <p>{{v.li5}}</p>
                  <span>{{v.li4}}</span>
                  <div>
                    <p>
                      {{v.li6}}
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <!-- <tr>
              <td width="9%">10:00</td>
              <td width="13%">www.cs</td>
              <td width="13%">CSS切图</td>
              <td width="13%">
                <p>待咨询</p>
              </td>
              <td width="13%">CSS切图</td>
              <td width="13%">CSS切图</td>
              <td width="13%" class="tob-t">
                <i v-if="!uhk">待接收</i>
                <div v-else>
                  <p>待咨询</p>
                  <span>10:00-11:00</span>
                  <div  class="scf2">
                    <p>
                      详情
                    </p>
                  </div>
                </div>
              </td>
              <td width="13%">CSS切图</td>
            </tr> -->
            </table>
        </div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content bg-purple">
        <div class="re-ri-top">
          a
        </div>
        <div class="re-ri-bon">
          <el-button  @click="ccsv2()" type="primary" style="margin-left: 16px;font-size: 18px;" class="ccd">
            添加排班
          </el-button>
          <ul>
            <li>
              <p>6</p>
              <span>待接收</span>
            </li>
             <li>
              <p>6</p>
              <span>待接收</span>
            </li>
             <li>
              <p>6</p>
              <span>待接收</span>
            </li>
             <li>
              <p>6</p>
              <span>待接收</span>
            </li>
          </ul>
          <el-drawer v-if="du_drawer" class="deawer" size="35%" title="我是标题" :visible.sync="drawer" :with-header="false">
            <h2>发布排班</h2>
          <el-form class="el-Form" ref="form" :model="form" label-width="120px">
            <el-form-item label="活动名称" v-if="nu">
              <el-input v-model="form.name" style=""></el-input>
            </el-form-item>
            <el-form-item label="发布人">
              <el-select v-model="form.region" placeholder="请选择发布人">
                <el-option label="发布人1" value="shanghai"></el-option>
                <el-option label="发布人2" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="人数限制">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="取消预约限时">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="重复发布">
              <el-radio-group v-model="form.resource">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="已选日期">
              <el-date-picker style="width: 100%;" v-model="value1"  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="星期几">
              <el-select v-model="form.region3" placeholder="星期一">
                <el-option label="星期一" value="shanghai"></el-option>
                <el-option label="星期二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="已选时段">
              <el-select v-model="form.region2" placeholder="已选时段">
                <el-option label="星期一" value="shanghai"></el-option>
                <el-option label="星期二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button>取消</el-button>
              <el-button type="primary">发布</el-button>
            </el-form-item>
          </el-form>
          </el-drawer>
          <el-drawer v-else class="deawer" size="35%" title="我是标题" :visible.sync="drawer" :with-header="false">
            <h2>预约详情</h2>
            <el-descriptions class="cww" title="用户信息" column="1">
              <!-- <div> -->
                  <el-descriptions-item label="用户名">kooriookami</el-descriptions-item><br>
                  <el-descriptions-item label="手机号">18100000000</el-descriptions-item>
                  <el-descriptions-item label="居住地">苏州市</el-descriptions-item>
                  <el-descriptions-item label="备注">
                    <el-tag size="small">学校</el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="联系地址">江道 1188 号</el-descriptions-item>
              <!-- </div> -->

          </el-descriptions>

          <el-descriptions class="cww" title="咨询信息" column="1">
              <!-- <div> -->
                  <el-descriptions-item label="用户名">kooriookami</el-descriptions-item><br>
                  <el-descriptions-item label="手机号">18100000000</el-descriptions-item>
                  <el-descriptions-item label="居住地">苏州市</el-descriptions-item>
                  <el-descriptions-item label="备注">
                    <el-tag size="small">学校</el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="联系地址">江道 1188 号</el-descriptions-item>
              <!-- </div> -->
          </el-descriptions>
          </el-drawer>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
  export default {
    data() {
      return {
        drawer: false,
        du_drawer: false,
        nu:false,
        uhk:false,
        value1:"",
        form: {
          name: '',
          region: '',
          region2: '',
          region3: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        list: [{
            li1: 1,
            li2: false,
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '待接受',
            li6: '接受',
          }, {
            li1: 2,
            li2: false,
            li3: '2020-10-01',
            li4: '9:00-10:00',
            li5: '待咨询',
            li6: '详情',
          },
          {
            li1: 1,
            li2: true,
            li3: '2020-10-01',
            li4: '10:00-11:00',
            li5: '待接受',
            li6: '接受',
          },{
            li1: 1,
            li2: false,
            li3: '2020-10-01',
            li4: '11:00-12:00',
            li5: '待接受',
            li6: '接受',
          },{
            li1: 2,
            li2: false,
            li3: '2020-10-01',
            li4: '13:00-13:00',
            li5: '待咨询',
            li6: '详情',
          },{
            li1: 3,
            li2: false,
            li3: '2020-10-01',
            li4: '9:00-10:00',
            li5: '已发布',
            li6: '详情',
          },
          {
            li1: 4,
            li2: false,
            li3: '',
            li4: '',
            li5: '',
            li6: '',
          }],
      };
    },
    methods:{
        showEwm(val,event) {
          this.list[val].li2 = !this.list[val].li2;
          // this.$forceUpdate();
        },
        ccsv(){
          this.du_drawer = false;
          this.drawer = true;
        },
        ccsv2(){
          this.du_drawer = true;
          this.drawer = true;
        }
    }
  };
</script>
<style scoped>
  .grid-content {background-color: #fff; }
  .re-ri-top{height: 310px;background-color: #ffe9cd;border-radius: 12px;}
  .re-ri-bon{height: 310px;border-radius: 12px;margin-top: 20px;}
  .deawer h2{padding-left: 40px;margin-top: 40px;margin-bottom: 60px;}
  .el-Form{width: 70%;margin-left: 20px;}
  .time-box span{margin-left: 50px;}
  .el-select{width: 100%;}
  .ccd{width: 100%;height: 88px;background-color: #409EFF;border-radius: 10px;margin-top: 20px;margin-left: 0px!important;}
  .re-ri-bon li {width: 45%;height: 90px;float: left;color: #fff;text-align: center;border-radius: 10px;margin-top: 18px;}
  .re-ri-bon li p{margin-top: 10px;padding-bottom: 6px;font-size: 24px;}
  .re-ri-bon li:nth-child(1){background-color: rgba(255, 91, 87, 1);}
  .re-ri-bon li:nth-child(2){background-color: rgba(74, 188, 119, 1);margin-left: 10%;}
  .re-ri-bon li:nth-child(3){background-color: rgba(247, 198, 35, 1);}
  .re-ri-bon li:nth-child(4){background-color: rgba(99, 101, 123, 1);margin-left: 10%;}
  .table-c table{border-right:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;text-align: center;}
  .table-c table td{border-left:1px solid #e2e2e2;border-top:1px solid #e2e2e2;text-align: center;height: 80px;}
  .tob{background-color: #ffdedd; color:rgba(255, 91, 87, 1);position: relative;}
  .tob>p{font-size: 18px;font-weight: 700;padding-bottom: 4px;}
  .scf{width: 41px;height: 80px;background-color: rgba(255, 91, 87, 1);border-top-left-radius: 0px;border-top-right-radius: 4px;border-bottom-right-radius: 4px;border-bottom-left-radius: 0px;position: absolute;right: -40px;top: 0px;color: #fff;font-size: 16px;text-align: center;}
  .scf p{width: 20px;margin: 0 auto;line-height: 30px;margin-top: 10px;}
  .scf2{width: 41px;height: 80px;background-color: #4abc77;border-top-left-radius: 0px;border-top-right-radius: 4px;border-bottom-right-radius: 4px;border-bottom-left-radius: 0px;position: absolute;right: -40px;top: 0px;color: #fff;font-size: 16px;text-align: center;}
  .scf2 p{width: 20px;margin: 0 auto;line-height: 30px;margin-top: 10px;}
  .tob-t{background-color: #edf8f1; color:#4abc77;position: relative;}
  .tob-t>p{font-size: 18px;font-weight: 700;padding-bottom: 4px;}
  .cww{margin-left:40px;}
</style>

